// extracted by mini-css-extract-plugin
module.exports = {"page":"LogoPage_page__3riOR","logo":"LogoPage_logo__3BoDW","gradient":"LogoPage_gradient__29cvz","opaque":"LogoPage_opaque__1AjDo"};